import { DefaultTheme } from 'styled-components';

import {
  breakpoints,
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  spacing,
  wrapper,
  zIndex,
} from '../constants';

export const lightTheme: DefaultTheme = {
  colors,
  fontSize,
  fontFamily,
  fontWeight,
  lineHeight,
  letterSpacing,
  spacing,
  wrapper,
  breakpoints,
  zIndex,
};
